/**
 * Static lists of statuses describing the presence/absence of an installation report
 */
export default [
  {
    key: 'registered',
    value: 'Registered',
    color: 'success.500',
    backgroundColor: 'success.50',
  },
  {
    key: 'unregistered',
    value: 'Not registered',
    color: 'error.500',
    backgroundColor: 'error.50',
  },
]
